export default __webpack_public_path__ + "static/Ringside-Book-2d7c537c3fd38230033ba3f22d664f9c.woff2";